export default {
  // Endpoints
  userUpdateEndpoind: 'user/update',
  changePasswordEndpoint: 'change/user/password',
}
